var React = require('react');

function SelectForm (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12 15.5L5 8.5H19L12 15.5Z","fill":"currentColor"}));
}

SelectForm.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = SelectForm;

SelectForm.default = SelectForm;
